var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);

// api/datev/buchungen.ts
import { Arg, Entity, Query } from "@adornis/baseql/decorators.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { loadMongoData } from "@adornis/baseql/server/data-loader.js";
import { ConvertConfig, FieldMappingEntry } from "@adornis/import-export/db/convert-config.js";
import { ExportJob } from "@adornis/import-export/db/export-job.js";
import { exportCSVBufferFromMongo } from "@adornis/import-export/server/export-internals.js";
import { DateTime } from "luxon";
import { accountingConfig } from "../../config.js";
import { Beleg } from "../beleg.js";
import { BuchungFilter } from "../buchung-filter.js";
import { Zusammenhangskomponente } from "../zusammenhangskomponente.js";
import { Buchung } from "./../buchung.js";
var serializeNumber = (num) => num?.toFixed(2).replaceAll(".", ",") ?? "";
var DatevBuchungenConvertConfig = class extends ConvertConfig {
  constructor(enitity) {
    super({
      className: enitity._class,
      delimiter: ";",
      fieldMappings: [
        new FieldMappingEntry(
          { input: "Umsatz (ohne Soll/Haben-Kz)", output: "betrag.betrag" },
          void 0,
          serializeNumber
        ),
        new FieldMappingEntry({ input: "Soll/Haben-Kennzeichen", output: null }, void 0, () => "S"),
        new FieldMappingEntry({ input: "WKZ Umsatz", output: null }),
        new FieldMappingEntry({ input: "Kurs", output: null }),
        new FieldMappingEntry({ input: "Basis-Umsatz", output: null }),
        new FieldMappingEntry({ input: "WKZ Basis-Umsatz", output: null }),
        new FieldMappingEntry({ input: "Konto", output: "sollKonto" }),
        new FieldMappingEntry({ input: "Gegenkonto (ohne BU-Schl\xFCssel)", output: "habenKonto" }),
        new FieldMappingEntry({ input: "BU-Schl\xFCssel", output: null }),
        new FieldMappingEntry(
          { input: "Belegdatum", output: "buchungsDatum" },
          void 0,
          (v) => v?.toFormat("dLL") ?? ""
        ),
        new FieldMappingEntry(
          { input: "Belegfeld 1", output: null },
          void 0,
          async (v, data) => {
            const zsmHaenge = await loadMongoData(Zusammenhangskomponente, { buchungsIDs: data._id });
            const belege = await loadMongoData(
              Beleg,
              zsmHaenge.flatMap((z) => z.belegIDs)
            );
            return belege[0]?.belegNummer ?? "";
          }
        ),
        new FieldMappingEntry(
          { input: "Belegfeld 2", output: null },
          void 0,
          async (v, data) => {
            const zsmHaenge = await loadMongoData(Zusammenhangskomponente, { buchungsIDs: data._id });
            const belege = await loadMongoData(
              Beleg,
              zsmHaenge.flatMap((z) => z.belegIDs)
            );
            return belege[1]?.belegNummer ?? "";
          }
        ),
        new FieldMappingEntry({ input: "Skonto", output: null }),
        new FieldMappingEntry(
          { input: "Buchungstext", output: null },
          void 0,
          async (v, data) => {
            const buchung = await Buchung.getEntityByID(data._class, [data._id])({ buchungsText: 1 });
            return buchung[0]?.buchungsText ?? "";
          }
        ),
        new FieldMappingEntry({ input: "Postensperre", output: null }),
        new FieldMappingEntry({ input: "Diverse Adressnummer", output: null }),
        new FieldMappingEntry({ input: "Gesch\xE4ftspartnerbank", output: null }),
        new FieldMappingEntry({ input: "Sachverhalt", output: null }),
        new FieldMappingEntry({ input: "Zinssperre", output: null }),
        new FieldMappingEntry({ input: "Beleglink", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Art 1", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Inhalt 1", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Art 2", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Inhalt 2", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Art 3", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Inhalt 3", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Art 4", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Inhalt 4", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Art 5", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Inhalt 5", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Art 6", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Inhalt 6", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Art 7", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Inhalt 7", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Art 8", output: null }),
        new FieldMappingEntry({ input: "Beleginfo - Inhalt 8", output: null }),
        new FieldMappingEntry(
          { input: "KOST1 - Kostenstelle", output: null },
          void 0,
          async (v, data) => data.kostenstellen?.[0]?.kostenstelle ?? ""
        ),
        new FieldMappingEntry(
          { input: "KOST2 - Kostenstelle", output: null },
          void 0,
          async (v, data) => data.kostenstellen?.[1]?.kostenstelle ?? ""
        ),
        new FieldMappingEntry({ input: "Kost-Menge", output: null }),
        new FieldMappingEntry({ input: "EU-Land u. UStID", output: null }),
        new FieldMappingEntry({ input: "EU-Steuersatz", output: null }),
        new FieldMappingEntry({ input: "Abw. Versteuerungsart", output: null }),
        new FieldMappingEntry({ input: "Sachverhalt L+L", output: null }),
        new FieldMappingEntry({ input: "Funktionserg\xE4nzung L+L", output: null }),
        new FieldMappingEntry({ input: "BU 49 Hauptfunktionstyp", output: null }),
        new FieldMappingEntry({ input: "BU 49 Hauptfunktionsnummer", output: null }),
        new FieldMappingEntry({ input: "BU 49 Funktionserg\xE4nzung", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 1", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 1", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 2", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 2", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 3", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 3", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 4", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 4", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 5", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 5", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 6", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 6", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 7", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 7", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 8", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 8", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 9", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 9", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 10", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 10", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 11", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 11", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 12", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 12", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 13", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 13", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 14", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 14", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 15", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 15", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 16", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 16", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 17", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 17", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 18", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 18", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 19", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 19", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation - Art 20", output: null }),
        new FieldMappingEntry({ input: "Zusatzinformation- Inhalt 20", output: null }),
        new FieldMappingEntry({ input: "St\xFCck", output: null }),
        new FieldMappingEntry({ input: "Gewicht", output: null }),
        new FieldMappingEntry({ input: "Zahlweise", output: null }),
        new FieldMappingEntry({ input: "Forderungsart", output: null }),
        new FieldMappingEntry({ input: "Veranlagungsjahr", output: null }),
        new FieldMappingEntry({ input: "Zugeordnete F\xE4lligkeit", output: null }),
        new FieldMappingEntry({ input: "Skontotyp", output: null }),
        new FieldMappingEntry({ input: "Auftragsnummer", output: null }),
        new FieldMappingEntry({ input: "Buchungstyp", output: null }),
        new FieldMappingEntry({ input: "Ust-Schl\xFCssel (Anzahlungen)", output: null }),
        new FieldMappingEntry({ input: "EU-Land (Anzahlungen)", output: null }),
        new FieldMappingEntry({ input: "Sachverhalt L+L (Anzahlungen)", output: null }),
        new FieldMappingEntry({ input: "EU-Steuersatz (Anzahlungen)", output: null }),
        new FieldMappingEntry({ input: "Erl\xF6skonto (Anzahlungen)", output: null }),
        new FieldMappingEntry({ input: "Herkunft-Kz", output: null }),
        new FieldMappingEntry({ input: "Leerfeld", output: null }),
        new FieldMappingEntry({ input: "KOST-Datum", output: null }),
        new FieldMappingEntry({ input: "Mandatsreferenz", output: null }),
        new FieldMappingEntry({ input: "Skontosperre", output: null }),
        new FieldMappingEntry({ input: "Gesellschaftername", output: null }),
        new FieldMappingEntry({ input: "Beteiligtennummer", output: null }),
        new FieldMappingEntry({ input: "Identifikationsnummer", output: null }),
        new FieldMappingEntry({ input: "Zeichnernummer", output: null }),
        new FieldMappingEntry({ input: "Postensperre bis", output: null }),
        new FieldMappingEntry({ input: "Bezeichnung SoBil-Sachverhalt", output: null }),
        new FieldMappingEntry({ input: "Kennzeichen SoBil-Buchung", output: null }),
        new FieldMappingEntry({ input: "Festschreibung", output: null }),
        new FieldMappingEntry({ input: "Leistungsdatum", output: null }),
        new FieldMappingEntry({ input: "Datum Zuord.Steuerperiode", output: null })
      ]
    });
  }
};
DatevBuchungenConvertConfig._class = "DatevBuchungenConvertConfig";
DatevBuchungenConvertConfig = __decorateClass([
  Entity()
], DatevBuchungenConvertConfig);
var BuchungenExportJob = class extends ExportJob {
  static exportBuchungen(className, filter) {
    return async () => {
      if (filter.from?.month !== filter.until?.month || filter.from?.year !== filter.until?.year)
        throw new Error("cant export across month boundaries");
      return `"EXTF";510;21;Buchungsstapel;7;${DateTime.now().toFormat(
        "yyyyMMddHHmmssSSS"
      )};;"";"";"";${accountingConfig.get("DATEV_BERATERNUMMER")};${accountingConfig.get(
        "DATEV_MANDANTENNUMMER"
      )};${DateTime.now().startOf("year").toFormat("yyyyMMdd")};7;${filter.from?.startOf("month").toFormat("yyyyMMdd")};${filter.until?.endOf("month").toFormat("yyyyMMdd")};"";;;;0;EUR;"";"";;"";;;"";"";
` + (await exportCSVBufferFromMongo(
        new DatevBuchungenConvertConfig(baseqlMetaData.entities.resolveNode(className).type()),
        filter.getMongoFilter()
      )).toString();
    };
  }
};
BuchungenExportJob._class = "BuchungenExportJob";
__decorateClass([
  Query((type) => String),
  __decorateParam(0, Arg("className", (type) => String)),
  __decorateParam(1, Arg("filter", (type) => BuchungFilter))
], BuchungenExportJob, "exportBuchungen", 1);
BuchungenExportJob = __decorateClass([
  Entity()
], BuchungenExportJob);
export {
  BuchungenExportJob,
  DatevBuchungenConvertConfig
};
